import { render, staticRenderFns } from "./WRegisterEntry.vue?vue&type=template&id=bf28f4de"
import script from "./WRegisterEntry.vue?vue&type=script&lang=js"
export * from "./WRegisterEntry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports